import React from 'react';
import ParameterDictionary from '../../../../../../../../../@Api/Automation/Parameter/ParameterDictionary';

export const ComputationParameterSuppressionContext = React.createContext<ParameterDictionary>(new ParameterDictionary([]));
